<script type="text/jsx" lang="jsx">
import BaseConfig from './base-config.vue'
import EditSimple from "./edit-simple.vue";
import planPropsMixin from "@/plans/mx/plan-props";

export default {
  mixins: [planPropsMixin],
  render() {
    const context = {...this.$props, ...this.$attrs};
    
    if (this.$context.is.edit && this.$context.is.simplify) {
      return <EditSimple />;
    }
    return <BaseConfig {...context} />;
  },
};
</script>
